module.exports = __webpack_public_path__ + "img/cdj.61166412.png";